import $ from 'jquery';
import tabParams from '../tab_params';
import { AJAX_PAGE_PER_COUNT } from '../consts/configs';
import {utf8Query} from "../consts/globals";

export function httpsToHttp(url) {
  return url.replace(/^https:\/\//, "http://");
}

export function toRelativeProtocol(url) {
  return url.replace(/^(http:|https:)/, window.location.protocol);
}

export function toParamString(paramObj) {
  let result = [];
  for (let key in paramObj) {
    if (paramObj.hasOwnProperty(key) && paramObj[key] !== null) {
      result.push(`${key}=${paramObj[key]}`);
    }
  }

  return result.join('&');
}

export function toParamObj(paramStr) {
  const result = {};
  $.each(paramStr.split('&'), function (idx, each) {
    const keyValueArr = each.split('=');
    result[keyValueArr[0]] = keyValueArr[1];
  });

  return result;
}

export function makeAjaxRequestUri(params) {
  // 클릭코드의 기본 값. pc/mo, tot/tab 별로 달라진다. 기본은 tab
  const basicCode = 'IIM';
  const addQsearchParam = '';
  const defaultParams = {
    'q': decodeURIComponent(utf8Query),
    'w': 'spread',
    'qsearch_ver': 'v2',
    'viewtype': 'json',
    'mk': window.mk,
    'uk': window.uk,
    'exp': basicCode + addQsearchParam,
    'lpp': AJAX_PAGE_PER_COUNT
  };
  const additionalParams = ['monochrome', 'clipart', 'lineart'];
  $.each(additionalParams, (idx, each) => {
    if (tabParams[each] === 'y') {
      defaultParams[each] = 'y';
    }
  });

  /**
   * PC
   * 버킷 테스트를 진행시, API에서도 버킷 결과를 받기 위해 bucket_type 파라미터 삽입.
   * */
  if (window.bucketType) {
    defaultParams['bucket_type'] = window.bucketType;
  }

  return SF.getQsUrl( $.extend({}, defaultParams, params), 1);
}


/** WEBPACK FOOTER **
 ** ./src/IIM/core/utils/url.js
 **/